import { Truck, Clock, RotateCcw, ShieldCheck, CreditCard } from "lucide-react";

const benefits = [
  { icon: Truck, title: "Doprava zadarmo", description: "od 20€" },
  { icon: Clock, title: "Expedícia do 24h", description: "v pracovné dni" },
  { icon: RotateCcw, title: "Vrátenie do 30 dní", description: "bez otázok" },
  { icon: ShieldCheck, title: "Bezpečný nákup", description: "SSL šifrovanie" },
  { icon: CreditCard, title: "Platba na splátky", description: "od 50€" },
];

export const ShopBenefits = () => {
  return (
    <section className="w-full bg-secondary/50 border-t border-border mt-auto">
      <div className="max-w-[1920px] mx-auto px-4 lg:px-8 py-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center group"
            >
              <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3 group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-300">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <p className="text-sm font-bold text-foreground mb-0.5">{benefit.title}</p>
              <p className="text-xs text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
